import dateFormatType from '@/constants/dateFormatType';
import brgI18n from '@/locales';
import { convertCase, currency, numberToFormatted, validateTextWithHypen, } from '@/utils';
import { getFormattedDate } from '@/utils/time';
export class WorkerProfit {
    _workerProfit;
    constructor(workerProfit) {
        this._workerProfit = workerProfit;
    }
    /** 허브명 */
    get formattedHubName() {
        return this._workerProfit.hubName;
    }
    /** 일시 */
    get formattedAdjustmentDate() {
        const isTypeDaily = this._workerProfit.adjustmentDate.length === 8;
        const responseFormat = isTypeDaily ? 'yyyyMMdd' : 'yyyyMM';
        const dateFormat = isTypeDaily ? dateFormatType.DATE : dateFormatType.MONTH;
        const formattedAdjustmentDate = getFormattedDate(this._workerProfit.adjustmentDate, responseFormat, dateFormat);
        return validateTextWithHypen(formattedAdjustmentDate);
    }
    /** 고용형태 */
    get formattedEmployeeType() {
        const employeeType = convertCase(this._workerProfit.employeeType, 'enum', 'snake');
        const employeeTypeText = brgI18n.global.t(`resource.worker.employee_type_option.${employeeType}`);
        return validateTextWithHypen(employeeTypeText);
    }
    /** 보수지급방식 */
    get formattedSalaryType() {
        const salaryType = convertCase(this._workerProfit.salaryType, 'enum', 'snake');
        const salaryTypeText = brgI18n.global.t(`resource.worker.salary_type_option.${salaryType}`);
        return validateTextWithHypen(salaryTypeText);
    }
    /** 라이더사번 */
    get formattedHubEmployeeNumber() {
        const { hubEmployeeNumber } = this._workerProfit;
        return validateTextWithHypen(hubEmployeeNumber);
    }
    /** 라이더코드 */
    get formattedWorkerCode() {
        const { workerCode } = this._workerProfit;
        return validateTextWithHypen(workerCode);
    }
    /** 라이더명 */
    get formattedWorkerName() {
        const { workerName } = this._workerProfit;
        return validateTextWithHypen(workerName);
    }
    /** 라이더바로머니마감금액 */
    get formattedWorkerBaromoneyClosingAmount() {
        const { workerBaromoneyClosingAmount } = this._workerProfit;
        return validateTextWithHypen(currency(workerBaromoneyClosingAmount));
    }
    /** 완료건수 */
    get formattedOrderFinishCount() {
        const { orderFinishCount } = this._workerProfit;
        const orderFinishCountWithSuffix = brgI18n.global.t('unit.count_suffix', {
            count: numberToFormatted(orderFinishCount),
        });
        return validateTextWithHypen(orderFinishCountWithSuffix);
    }
    /** 배달대행료금액 */
    get formattedDeliveryAdjustAmount() {
        const { deliveryAdjustAmount } = this._workerProfit;
        return validateTextWithHypen(currency(deliveryAdjustAmount));
    }
    /** 배달대행수수료 */
    get formattedDeliveryFee() {
        const { deliveryFee } = this._workerProfit;
        return validateTextWithHypen(currency(deliveryFee));
    }
    /** 라이더수익 */
    get formattedWorkerProfit() {
        const { workerProfit } = this._workerProfit;
        return validateTextWithHypen(currency(workerProfit));
    }
    /** 원천세 */
    get formattedWorkerWithholdingTax() {
        const { workerWithholdingTax } = this._workerProfit;
        return validateTextWithHypen(currency(workerWithholdingTax));
    }
    /** 바로머니정산합계 */
    get formattedBaromoneyAdjustAmountSum() {
        const { baromoneyAdjustAmountSum } = this._workerProfit;
        return validateTextWithHypen(currency(baromoneyAdjustAmountSum));
    }
    /** 현금상품액 */
    get formattedPayCashAmount() {
        const { payCashAmount } = this._workerProfit;
        return validateTextWithHypen(currency(payCashAmount));
    }
    /** 회사입금액 */
    get formattedCompanyDepositAmount() {
        const { companyDepositAmount } = this._workerProfit;
        return validateTextWithHypen(currency(companyDepositAmount));
    }
}
